import DiscoverFilter from './DiscoverFilter';

export default DiscoverFilter;
